import { createAction } from '@reduxjs/toolkit';
import * as types from './type';

const EnableTealiumStatus = createAction(types.ENABLE_TEAILUM_STATUS);

const setEnableTealiumStatus = enable => {
  return dispatch => {
    if (enable) {
      window.enableTealium();
    }

    dispatch(EnableTealiumStatus(enable));
  };
};

export default setEnableTealiumStatus;
